var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React from 'react';
import { Chip, PercentageIcon } from '@honeycomb/ui-core';
import { TripType, useGlobalContext, useModal, useSearch } from '@honeycomb/data';
import { interjectResourceString } from '../../../utils/interjectResourceString';
export function HotelDepositPill(_a) {
    var { depositFormatted, chipProps } = _a, other = __rest(_a, ["depositFormatted", "chipProps"]);
    const [_currentModal, setCurrentModal] = useModal();
    const [{ tripType }] = useSearch([]);
    const { resourceStrings: { HC_SECURETODAYFROM, HC_HOLIDAYS_SECURETODAYFROM, PAYLOWDEPOSIT, SECURE_TODAY_AND_PAY_BY, DEPOSITFEE, }, } = useGlobalContext();
    const handleClick = (event) => {
        event.preventDefault();
        event.stopPropagation();
        const holidayText = TripType.Holiday.toLowerCase();
        const replacementText = { holidayText, depositFormatted };
        setCurrentModal({
            isOpen: true,
            heading: PAYLOWDEPOSIT,
            body: `<p>${interjectResourceString(SECURE_TODAY_AND_PAY_BY, replacementText)}</p><p>${DEPOSITFEE}</p>`,
        });
    };
    const secureTodayPillFormatted = interjectResourceString(tripType === TripType.Hotel ? HC_SECURETODAYFROM : HC_HOLIDAYS_SECURETODAYFROM, depositFormatted);
    return (React.createElement(Chip, Object.assign({ color: "neutral", icon: tripType === TripType.Hotel ? React.createElement(PercentageIcon, null) : undefined, onClick: handleClick, "data-id": "deposit-pill" }, chipProps, other), secureTodayPillFormatted));
}
